import moment from 'moment'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import VueRangeDatepicker from './components/VueRangeDatepicker.vue'

export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      valueStart: this.modelProps[this.config.startDateFieldName] 
        && this.modelProps[this.config.startDateFieldName] instanceof firebase.firestore.Timestamp ? this.modelProps[this.config.startDateFieldName].toDate() : 
        this.modelProps[this.config.startDateFieldName] && this.modelProps[this.config.startDateFieldName] instanceof Date ?
        this.modelProps[this.config.startDateFieldName] : '',
      valueEnd: this.modelProps[this.config.endDateFieldName] && this.modelProps[this.config.endDateFieldName] instanceof firebase.firestore.Timestamp ? this.modelProps[this.config.endDateFieldName].toDate() : 
        this.modelProps[this.config.endDateFieldName] && this.modelProps[this.config.endDateFieldName] instanceof Date ? this.modelProps[this.config.endDateFieldName] : '',
      value: '',
      moment: moment
    }
  },
  created () {
    if (this.valueStart && this.valueEnd) {
      this.value = `${moment(this.valueStart).format(this.$store.state.config.defaultDateFormat)} ~ ${moment(this.valueEnd).format(this.$store.state.config.defaultDateFormat)}`
    }
  },
  watch: {
    value (newValue) {
      let splited = newValue.split('~')
      if (splited.length > 1) {
        this.valueStart = splited[0]
        this.valueEnd = splited[1]
      } else {
        this.valueStart = splited[0]
        this.valueEnd = splited[0]
      }
      this.updateModel(this.config.startDateFieldName, this.valueStart)
      this.updateModel(this.config.endDateFieldName, this.valueEnd)
      this.$emit('notifyChange', this.modelProps)
    }
  },
  methods: {
    updateModel(fieldName, value) {
      if(this.config.nativeDate) {
        this.modelProps[fieldName] = moment.utc(value, this.$store.state.config.defaultDateFormat).toDate()
      } else {
        this.modelProps[fieldName] = firebase.firestore.Timestamp.fromDate(moment.utc(value, this.$store.state.config.defaultDateFormat).toDate())
      }
    },
    validate () {
      this.$refs[this._uid].validate()
    }
  },
  components: {
    VueRangeDatepicker
  }
}
